
import Vue from "vue";
import { getUserCompanies } from "@/helpers/companies";
import { Platform } from "@/types";
import { ICompany } from "@/store/modules/companies/types";
export default Vue.extend({
  name: "UserCompanies",
  props: {
    companies: {
      type: Array as () => ICompany[],
      required: false,
      default: () => []
    },
    pageTitle: {
      type: String,
      required: false
    },
    pageDescription: {
      type: String,
      required: true,
      default: ""
    },
    platform: {
      type: String as () => Platform,
      required: false,
      default: "profile"
    }
  },

  computed: {
    userCompanies(): ICompany[] {
      return this.companies && this.companies.length > 0
        ? this.companies
        : getUserCompanies(this.platform as Platform);
    }
  }
});
